
import {
  INIT_PRODUCTS_INFO,
  REQUEST_PRODUCTS_START,
  REQUEST_PRODUCTS_SUCCESS,
  REQUEST_PRODUCTS_FAIL,
} from '../actions/products';

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

  const { type, data, payload, error } = action;

  switch (type) {

    case REQUEST_PRODUCTS_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_PRODUCTS_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_PRODUCTS_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case INIT_PRODUCTS_INFO:
      {
        return initialState;
      }

    default:
      {
        return { ...state };
      }
  }
};

export default reducer;
